import api from "./api";
import config from "../config";

export default {
  fetchOnlineBallotData(apiKey, eventId, tickets) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `ballots/online_ballot_data`,
          qs: { event_id: eventId, tickets: tickets },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchVotes(apiKey, eventId) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `ballots/votes`,
          qs: { event: eventId },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/BallotUtil.js